import { signalsLineText, type AgentSignals } from "@sill/shared/lib/signals-copy";

/**
 * The agent's signals line (plan 444 M4): licensed years, closes, and
 * responsiveness, or only the joined month for a new agent. The line is
 * display-only plain text and renders nothing when there is nothing present
 * to say.
 */
export function SignalsLine({
  className = "text-xs text-muted-foreground",
  signals,
  testId = "agent-signals-line",
}: {
  className?: string;
  signals: AgentSignals | null | undefined;
  testId?: string;
}) {
  const text = signalsLineText(signals);
  if (!text) return null;
  return (
    <p className={className} data-testid={testId}>
      {text}
    </p>
  );
}
